// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__rwzj-","title":"Header_title__3VwPx","side":"Header_side__35Ll_"};